import MobileNav from 'gatsby-theme-husky/src/components/Header/HeaderNav/MobileNav/MobileNav';

import './MobileNavOverride.scss';

export default MobileNav;
